// extracted by mini-css-extract-plugin
var _1 = "EmailMessageTags-moduleEmailMessageTags__cceOn";
export { _1 as "EmailMessageTags" }
